import React from 'react'
import { Select } from 'antd'
import naming_icon from '../../../../images/example.png'
import vip_icon from '../assets/vip_icon.png'
import CONFIG from '../../../../constants/config'
import { generateExampleName, sensorsNameRule } from '../utils'
import { CaretDownOutlined } from '@ant-design/icons'

const Option = Select.Option

const NamingSection = ({
  namingRule,
  photoTitleList,
  onChangeSelectNameData,
  vipKind,
  isVip,
  renameTrialLeft,
  renameTrialLimit,
  track
}) => {
  const exampleName = generateExampleName(namingRule, photoTitleList)

  const isBasicMember =
    isVip &&
    vipKind !== CONFIG.VIP_KIND.SVIP &&
    vipKind !== CONFIG.VIP_KIND.VVIP
  // 判断是否选中了高级命名（不包含基础三项）
  const hasAdvancedNaming =
    namingRule &&
    Array.isArray(namingRule) &&
    namingRule.some(
      (rule) => rule !== 'user' && rule !== 'time' && rule !== 'watermark'
    )
  // 如果是普通会员且选中了高级命名则展示试用标签；当 renameTrialLeft 可用时展示剩余次数，否则展示“试用中”
  const showTrialText = isBasicMember && hasAdvancedNaming

  return (
    <div className="rule-block" style={{ marginTop: '20px' }}>
      <div className="rule-title">
        <div>
          <span className="title">照片/视频命名方式</span>{' '}
          {isBasicMember && showTrialText && (
            <span className="trial-text">
              {typeof renameTrialLeft === 'undefined'
                ? '高级命名试用中'
                : `高级命名试用 ${renameTrialLimit - renameTrialLeft || 0}/${
                    renameTrialLimit || 5
                  }`}
            </span>
          )}
        </div>
      </div>
      {namingRule.length ? (
        <div>
          <div className="example example-naming">
            <img src={naming_icon} alt="" />
            <p>{exampleName}</p>
          </div>
        </div>
      ) : (
        <p style={{ color: '#f5222d', marginLeft: '16px' }}>请至少选择一项</p>
      )}
      <Select
        mode="tags"
        style={{
          width: 'calc(100% - 32px)',
          margin: '0px 16px',
          color: '#000'
        }}
        className="select-mutil-tag"
        suffixIcon={<CaretDownOutlined />}
        showArrow
        placeholder="请选择或输入内容进行命名"
        disabled={false}
        value={namingRule}
        popupClassName="dropdown-tag"
        onChange={(value) => {
          onChangeSelectNameData(value)
          if (track) {
            const arr = Array.isArray(value) ? value : [value]
            track('照片命名选择完成', {
              namingMethod: sensorsNameRule(arr, photoTitleList)
            })
          }
        }}
      >
        {/* 固定前三项顺序：拍摄人姓名、拍摄日期、水印名称 */}
        <Option key="user">拍摄人姓名</Option>
        <Option key="time">拍摄日期</Option>
        <Option key="watermark">水印名称</Option>
        {/* 其余项放后面并标记为 VIP（图标） */}
        <Option key="address">
          <span style={{ display: 'inline-flex', alignItems: 'center' }}>
            拍摄地点
            <img
              src={vip_icon}
              alt="vip"
              style={{ width: 14, height: 14, marginLeft: 6 }}
            />
          </span>
        </Option>
        <Option key="photoNumber">
          <span style={{ display: 'inline-flex', alignItems: 'center' }}>
            照片编号
            <img
              src={vip_icon}
              alt="vip"
              style={{ width: 14, height: 14, marginLeft: 6 }}
            />
          </span>
        </Option>
        {photoTitleList.map((item) => (
          <Option key={'title' + item.titleId}>
            <span style={{ display: 'inline-flex', alignItems: 'center' }}>
              {item.titleName}
              <img
                src={vip_icon}
                alt="vip"
                style={{ width: 14, height: 14, marginLeft: 6 }}
              />
            </span>
          </Option>
        ))}
      </Select>
    </div>
  )
}

export default NamingSection
